// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.email-campaign-container {
  min-height: 83vh;
  margin-top: 20px;
}

/* --- Recipients dropdown overrides (Send To / Don't Send To) --- */
.recipients-section {
  gap: 8px !important;
}

.recipients-section .filter-dropdown .ant-select-selection-overflow {
  flex-wrap: nowrap !important;
  overflow: hidden !important;
}

.recipients-section .filter-dropdown .ant-select-selection-overflow-item {
  flex: 0 0 auto !important;
}

.recipients-section .filter-dropdown .ant-select-selection-search,
.recipients-section .filter-dropdown .ant-select-selection-search-input {
  width: 0 !important;
  min-width: 0 !important;
  height: 0 !important;
  opacity: 0 !important;
  caret-color: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
}

.recipients-section .campaign-select-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #e4e4e4;
  border-radius: 12px;
  padding: 0 10px;
  font-size: 14px;
  color: #000000;
  height: 26px;
  line-height: 22px;
  max-width: 100%;
}

.recipients-section .campaign-select-tag__prefix {
  font-weight: 600;
  color: #1a1a1a;
}

.recipients-section .campaign-select-tag__label {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recipients-section .campaign-select-tag__remove {
  margin-left: 4px;
  cursor: pointer;
}

.recipients-section .campaign-select-tag--rest {
  font-weight: 600;
}

.email-campaign-setup {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  max-width: 1300px;
  margin: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.page-header {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  gap: 14px;
  text-align: center;
}

.Page-header-text {
  justify-content: center !important;
  margin-top: -15px;
}

.page-header .back-button {
  background: #ffffff;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 5%;
  width: 38px !important;
  height: 28px;
}

.page-header .back-button img {
  width: 28px;
  height: 20px;
}

.form-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
  margin-left: 37px;
}

.form-group {
  margin-bottom: 15px;
  margin-left: 37px;
}
.form-group .form-label {
  display: block;
  font-size: 16px;
  margin-bottom: 6px;
  color: #6b7280;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
}
.form-group .form-input {
  width: 400px !important;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  margin-bottom: 0;
}

.recipients-section {
  display: flex;
  margin: 30px 0;
  align-items: flex-start;
}
.recipients-section .filter-dropdown {
  width: 320px !important;
  flex: 0 0 320px !important;
}
.recipients-section .filter-dropdown:first-child {
  margin-left: 37px !important;
}

.campaign-select-tag__prefix {
  color: #777 !important;
  font-size: 14px;
  margin-right: 6px;
}

.send-to-btn {
  width: 240px;
  margin-left: 37px;
}

.send-to-btn.styled-input.ant-input-affix-wrapper {
  height: 38px;
  border-radius: 4px;
  border: 1px solid #2c68ad;
  background: #ffffff;
  box-shadow: none;
  padding: 0 12px;
}

.send-to-btn .ant-input-prefix {
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 400;
  margin-right: 12px;
}

.send-to-btn .ant-input {
  font-size: 12px;
  color: #6b7280;
}

.send-to-btn .ant-input-suffix {
  color: #6b7280;
}

.send-to-btn.styled-input--has-value,
.send-to-btn.styled-input--has-value:hover,
.send-to-btn.styled-input--has-value.ant-input-affix-wrapper-focused {
  background: #ffffff !important;
  border-color: #2c68ad !important;
}

/* -------------------- Don’t Send To -------------------- */
.dont-send-btn {
  background: #f5f6f8;
  color: #1a1a1a;
  border: 2px solid #2c68ad;
  padding: 20px 16px;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  font-weight: 400;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Open Sans", sans-serif;
}

.dont-send-btn .recipient-heading {
  color: #000000;
  font-size: 14px;
}

.dont-send-btn .recipient-value {
  display: inline-block;
  max-width: 160px; /* adjust as needed */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  margin-left: 6px;
}

.dont-send-btn {
  gap: 8px;
}

.dont-send-btn .optional {
  font-weight: 400;
  color: #9ca3af;
  margin-left: 4px;
}

.dont-send-btn:hover,
.dont-send-btn:focus {
  background: #2c68ad !important;
  color: #ffffff !important;
  border: none;
}

.dont-send-btn:hover .recipient-heading,
.dont-send-btn:focus .recipient-heading {
  color: #ffffff !important;
}

.dont-send-btn:hover .recipient-value,
.dont-send-btn:focus .recipient-value {
  color: #ffffff !important;
}

.dont-send-dropdown {
  z-index: 2000 !important;
  position: absolute !important;
  overflow: visible !important;
  border-radius: 4px !important;
  min-width: 120px !important;
  width: 250px;
  max-height: 300px !important;
  overflow-y: auto !important;
}

.dont-send-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.dont-send-optional {
  font-size: 12px;
  color: #9ca3af;
  margin-left: 6px;
  line-height: 1;
  margin-top: -2px;
}

/* Force wrapper height to content (fix large gap under Don't Send To) */
.dont-send-wrapper {
  height: auto !important;
  min-height: 0 !important;
}

.dont-send-select.custom-dropdown,
.dont-send-select.custom-dropdown .ant-select-selector {
  height: 38px !important;
  min-height: 38px !important;
}

.send-to-btn {
  width: 240px;
  margin-left: 37px;
  flex: 0 0 240px;
}

.dont-send-btn {
  width: 240px;
  flex: 0 0 240px;
}

.send-to-btn.styled-input.ant-input-affix-wrapper,
.dont-send-btn.styled-input.ant-input-affix-wrapper {
  height: 38px;
  border-radius: 4px;
  border: 1px solid #2c68ad;
  background: #ffffff;
  box-shadow: none;
  padding: 0 12px;
  width: 240px !important;
}

.send-to-btn .ant-input-prefix,
.dont-send-btn .ant-input-prefix {
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 400;
  margin-right: 12px;
}

.send-to-btn .ant-input,
.dont-send-btn .ant-input {
  font-size: 12px;
  color: #6b7280;
}

.send-to-btn .ant-input-suffix,
.dont-send-btn .ant-input-suffix {
  color: #6b7280;
}

.send-to-btn.styled-input.ant-input-affix-wrapper:hover,
.dont-send-btn.styled-input.ant-input-affix-wrapper:hover,
.send-to-btn.styled-input.ant-input-affix-wrapper-focused,
.dont-send-btn.styled-input.ant-input-affix-wrapper-focused {
  background: #ffffff !important;
  border-color: #2c68ad !important;
}

/* --- StyledDropdown layout for Send To / Don't Send To --- */
.send-to-btn.custom-dropdown,
.dont-send-btn.custom-dropdown {
  width: 240px;
}

.send-to-btn.custom-dropdown .ant-select-selector,
.dont-send-btn.custom-dropdown .ant-select-selector {
  height: 38px !important;
  min-height: 38px !important;
  border-radius: 4px !important;
  border: 1px solid #2c68ad !important;
  background: #ffffff !important;
  box-shadow: none !important;
  padding: 0 12px !important;
  display: flex !important;
  align-items: center !important;
  position: relative;
}

.send-to-btn.custom-dropdown .ant-select-selection-overflow,
.dont-send-btn.custom-dropdown .ant-select-selection-overflow {
  height: 38px !important;
  min-height: 38px !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  overflow: hidden !important;
}

.send-to-btn.custom-dropdown .ant-select-selection-overflow-item,
.dont-send-btn.custom-dropdown .ant-select-selection-overflow-item {
  height: 38px !important;
  display: inline-flex !important;
  align-items: center !important;
}

.send-to-btn.custom-dropdown .ant-select-selection-search,
.dont-send-btn.custom-dropdown .ant-select-selection-search {
  height: 38px !important;
  display: inline-flex !important;
  align-items: center !important;
}

.send-to-btn.custom-dropdown .ant-select-selection-search-input,
.dont-send-btn.custom-dropdown .ant-select-selection-search-input {
  height: 38px !important;
}

.send-to-btn.custom-dropdown .ant-select-selector::before {
  content: "Send To";
  position: absolute;
  left: 12px;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 400;
}

.dont-send-btn.custom-dropdown .ant-select-selector::before {
  content: "Don't Send To";
  position: absolute;
  left: 12px;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 400;
}

.send-to-btn.custom-dropdown .ant-select-selection-search,
.send-to-btn.custom-dropdown .ant-select-selection-placeholder,
.send-to-btn.custom-dropdown .ant-select-selection-item,
.dont-send-btn.custom-dropdown .ant-select-selection-search,
.dont-send-btn.custom-dropdown .ant-select-selection-placeholder,
.dont-send-btn.custom-dropdown .ant-select-selection-item {
  padding-left: 72px !important;
}

.dont-send-btn.custom-dropdown .ant-select-selection-search,
.dont-send-btn.custom-dropdown .ant-select-selection-placeholder,
.dont-send-btn.custom-dropdown .ant-select-selection-item {
  padding-left: 104px !important;
}

.send-to-btn.custom-dropdown .ant-select-selection-overflow,
.dont-send-btn.custom-dropdown .ant-select-selection-overflow {
  flex-wrap: nowrap !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  align-items: center !important;
}

.send-to-btn.custom-dropdown .ant-select-selection-overflow-item,
.dont-send-btn.custom-dropdown .ant-select-selection-overflow-item {
  flex: 0 1 auto !important;
}

.campaign-select-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1;
}

.campaign-select-tag__remove {
  font-size: 12px;
  color: #9ca3af;
  cursor: pointer;
}

.send-to-btn.custom-dropdown .ant-select-selection-placeholder,
.dont-send-btn.custom-dropdown .ant-select-selection-placeholder,
.send-to-btn.custom-dropdown .ant-select-selection-item,
.dont-send-btn.custom-dropdown .ant-select-selection-item {
  font-size: 12px !important;
  color: #6b7280 !important;
}

.send-to-btn.custom-dropdown .styled-dropdown-caret,
.dont-send-btn.custom-dropdown .styled-dropdown-caret {
  display: block;
}

/* --- Final overrides for new StyledDropdown classes --- */
.send-to-select.custom-dropdown,
.dont-send-select.custom-dropdown {
  width: 320px !important;
  flex: 0 0 320px !important;
  height: 38px !important;
}

.send-to-select.custom-dropdown {
  margin-left: 37px !important;
}

.send-to-select.custom-dropdown .ant-select-selector,
.dont-send-select.custom-dropdown .ant-select-selector {
  height: 48px !important;
  min-height: 38px !important;
  border-radius: 8px !important;
  border: 1px solid #2c68ad !important;
  background: #ffffff !important;
  box-shadow: none !important;
  padding: 0 12px !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  overflow: hidden !important;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
}

.send-to-select.custom-dropdown .ant-select-selector::before {
  content: none !important;
}

.dont-send-select.custom-dropdown .ant-select-selector::before {
  content: none !important;
}

.send-to-select.custom-dropdown .ant-select-selection-search,
.send-to-select.custom-dropdown .ant-select-selection-placeholder,
.send-to-select.custom-dropdown .ant-select-selection-item,
.dont-send-select.custom-dropdown .ant-select-selection-search,
.dont-send-select.custom-dropdown .ant-select-selection-placeholder,
.dont-send-select.custom-dropdown .ant-select-selection-item {
  padding-left: 0 !important;
}

.dont-send-select.custom-dropdown .ant-select-selection-search,
.dont-send-select.custom-dropdown .ant-select-selection-placeholder,
.dont-send-select.custom-dropdown .ant-select-selection-item {
  padding-left: 0 !important;
}

.send-to-select.custom-dropdown .ant-select-selection-overflow,
.dont-send-select.custom-dropdown .ant-select-selection-overflow {
  height: 38px !important;
  min-height: 38px !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  overflow: hidden !important;
  white-space: nowrap !important;
}

.send-to-select.custom-dropdown .ant-select-selection-overflow {
  padding-left: 0 !important;
}

.dont-send-select.custom-dropdown .ant-select-selection-overflow {
  padding-left: 0 !important;
}

.send-to-select.custom-dropdown .ant-select-selection-overflow-item,
.dont-send-select.custom-dropdown .ant-select-selection-overflow-item {
  height: 38px !important;
  display: inline-flex !important;
  align-items: center !important;
  flex: 0 1 auto !important;
}

.send-to-select.custom-dropdown .ant-select-selection-search-input,
.dont-send-select.custom-dropdown .ant-select-selection-search-input {
  height: 0 !important;
  width: 0 !important;
  min-width: 0 !important;
  opacity: 0 !important;
  caret-color: transparent !important;
}

.send-to-select.custom-dropdown .ant-select-selection-search,
.dont-send-select.custom-dropdown .ant-select-selection-search {
  width: 0 !important;
  min-width: 0 !important;
  height: 0 !important;
  flex: 0 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

.send-to-select.custom-dropdown .ant-select-selection-item,
.dont-send-select.custom-dropdown .ant-select-selection-item {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.send-to-select.custom-dropdown:hover .ant-select-selector,
.dont-send-select.custom-dropdown:hover .ant-select-selector,
.send-to-select.custom-dropdown.ant-select-focused .ant-select-selector,
.dont-send-select.custom-dropdown.ant-select-focused .ant-select-selector {
  background: #ffffff !important;
  border-color: #2c68ad !important;
}

.send-to-btn.styled-input--has-value,
.dont-send-btn.styled-input--has-value,
.send-to-btn.styled-input--has-value:hover,
.dont-send-btn.styled-input--has-value:hover,
.send-to-btn.styled-input--has-value.ant-input-affix-wrapper-focused,
.dont-send-btn.styled-input--has-value.ant-input-affix-wrapper-focused {
  background: #ffffff !important;
  border-color: #2c68ad !important;
}

.ai-generator {
  margin: 0 -20px -20px -20px;
  margin-top: 50px;
  padding: 18px 0;
  border-top: 1px solid #cbd5e1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  background-color: #2c68ad;
  border-radius: 8px;
}

.ai-content {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 30px;
}

.ai-icon {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  display: block;
  align-self: center;
}

.ai-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  line-height: 1.3;
}

.ai-label {
  color: #ffffff;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
}

.ai-subtext {
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin-right: 40px !important;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbd5e1;
  transition: 0.4s;
  border-radius: 20px;
}

.switch .slider::before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  top: 1px;
  bottom: 3px;
  background-color: #ffffff;
  transition: 0.4s;
  border-radius: 50%;
}

.switch input:checked + .slider {
  background-color: #03045e;
}

.switch input:checked + .slider::before {
  transform: translateX(20px);
}

.footer-actions {
  display: flex;
  justify-content: flex-end; /* align buttons to right */
  align-items: center;
  gap: 12px; /* spacing between buttons */
  margin-top: 20px;
  margin-right: 45px;
}

.campaign-cancel-btn,
.campaign-next-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  min-width: 150px; /* keep uniform button size */
  text-align: center;
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
}

/* Cancel Button */
.campaign-cancel-btn {
  background: #f5f6f8;
  color: #9ca3af;
  border: 2px solid #ff6c00;
}

.campaign-cancel-btn:hover {
  background: #fafafa;
  color: #9ca3af;
}

/* Next Button */
.campaign-next-btn {
  background: #2c68ad;
  color: #ffffff;
  border: none;
}

.campaign-next-btn:hover {
  background: #3079bb;
  border: 2px solid #ff6c00 !important;
}

/* =========================================
   📱 MOBILE (max-width: 468px)
   ========================================= */
@media (max-width: 468px) {
  .email-campaign-container {
    margin-top: 10px;
    min-height: auto;
    padding: 0 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }
  .email-campaign-setup {
    padding: 15px;
    box-shadow: none;
    border-radius: 4px;
  }
  .page-header {
    flex-direction: row;
    gap: 8px;
    font-size: 12px;
    text-align: left;
  }
  .form-title {
    font-size: 20px;
    margin-left: 0;
  }
  .form-group {
    margin-left: 0;
  }
  .form-group .form-label {
    font-size: 14px;
  }
  .form-group .form-input {
    width: 100%;
    font-size: 14px;
    padding: 8px;
  }
  .setup-box__button {
    justify-content: center;
  }
  .recipients-section {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    margin: 20px 0;
  }
  .send-to-btn,
  .dont-send-btn {
    width: 100%;
    padding: 16px;
    font-size: 12px;
    margin-left: 0;
    justify-content: space-between;
  }
  .send-to-btn,
  .dont-send-btn span {
    font-size: 12px;
  }
  .dont-send-btn .recipient-value {
    font-size: 12px;
  }
  .ai-generator {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 15px;
  }
  .ai-text {
    margin-left: 0;
    gap: 4px;
  }
  .ai-next-btn {
    margin-right: -320px !important;
  }
  .switch {
    margin-right: 0 !important;
    align-self: flex-end;
  }
  .footer-actions {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 10px;
    margin: 20px 0 0 0;
  }
  .categories-step .categories-grid {
    margin-left: 9px !important;
  }
  .datetime-row {
    margin-left: 30px !important;
  }
  .summary-grid {
    grid-template-columns: 1fr !important;
    gap: 10px !important;
    margin-left: 9px !important;
  }
  .export-campaign-btn {
    margin-bottom: 20px !important;
  }
  .email-search-bar {
    width: 110% !important;
    margin-left: 10px !important;
  }
  .ai-back-btn {
    margin-right: 70px !important;
  }
  .campaign-cancel-btn,
  .campaign-next-btn {
    width: 100%;
    min-width: unset;
    font-size: 16px;
  }
  .campaign-type-grid {
    grid-template-columns: 1fr !important;
    gap: 10px !important;
  }
  .summary-item {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .summary-item label {
    flex: 0 0 40%; /* label takes 40% width */
    margin-bottom: 0; /* remove extra spacing */
    text-align: left;
    font-size: 12px !important;
  }
  .summary-item .form-input-summary {
    flex: 1 1; /* input stretches to fill remaining space */
    width: 100%;
  }
}
.custom-menu .ant-dropdown-menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  font-family: "Open Sans", sans-serif;
}

.custom-menu .selected-item {
  background-color: rgba(44, 104, 173, 0.15); /* light blue background for selected */
  font-weight: 600;
  color: #1a1a1a;
}

.menu-item-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.remove-icon {
  margin-left: 8px;
  color: #9ca3af;
  font-weight: bold;
  cursor: pointer;
}

.remove-icon:hover {
  color: #1a1a1a;
}

/* --- Overrides for new dropdown inputs --- */
.dont-send-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

.dont-send-optional {
  font-size: 12px;
  color: #9ca3af;
  margin-left: 6px;
}

.send-to-btn,
.dont-send-btn {
  width: 240px;
  flex: 0 0 240px;
}

.send-to-btn {
  margin-left: 37px;
}

.send-to-btn.custom-dropdown,
.dont-send-btn.custom-dropdown {
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.send-to-btn.styled-input.ant-input-affix-wrapper,
.dont-send-btn.styled-input.ant-input-affix-wrapper {
  height: 38px !important;
  min-height: 38px !important;
  border-radius: 4px !important;
  border: 1px solid #2c68ad !important;
  background: #ffffff !important;
  box-shadow: none !important;
  padding: 0 12px !important;
  width: 240px !important;
}

.send-to-btn .ant-input-prefix,
.dont-send-btn .ant-input-prefix {
  color: #1a1a1a !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  margin-right: 12px !important;
  white-space: nowrap;
}

.send-to-btn .ant-input,
.dont-send-btn .ant-input {
  font-size: 12px !important;
  color: #6b7280 !important;
  white-space: nowrap;
}

.send-to-btn.custom-dropdown .ant-select-selection-item,
.dont-send-btn.custom-dropdown .ant-select-selection-item {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.send-to-btn .ant-input-suffix,
.dont-send-btn .ant-input-suffix {
  color: #6b7280 !important;
}

.send-to-btn.styled-input.ant-input-affix-wrapper:hover,
.dont-send-btn.styled-input.ant-input-affix-wrapper:hover,
.send-to-btn.styled-input.ant-input-affix-wrapper-focused,
.dont-send-btn.styled-input.ant-input-affix-wrapper-focused {
  background: #ffffff !important;
  border-color: #2c68ad !important;
}

/* --- Final fixes: header + dont-send optional gap --- */
.page-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 0 12px;
}

.page-header .back-button--text {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: #2c68ad;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.page-header .back-button--text:hover {
  background: #3079bb;
}

.Page-header-text {
  margin-top: 0 !important;
  text-align: center;
  max-width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dont-send-wrapper {
  height: auto !important;
  min-height: 0 !important;
  align-self: flex-start;
  gap: 6px !important;
  margin-top: 0 !important;
}

.dont-send-select.custom-dropdown,
.dont-send-select.custom-dropdown .ant-select-selector {
  height: 38px !important;
  min-height: 38px !important;
}

.dont-send-select.custom-dropdown .ant-select-selection-overflow {
  height: 38px !important;
  min-height: 38px !important;
}

.dont-send-optional {
  margin-top: 6px !important;
  line-height: 1;
}

/* Hard clamp: don't allow the Don't Send To control to stretch */
.dont-send-wrapper {
  max-height: 60px !important;
}

.dont-send-select.custom-dropdown {
  display: inline-flex !important;
  align-items: center !important;
  height: 38px !important;
  min-height: 38px !important;
  max-height: 38px !important;
}

.dont-send-select.custom-dropdown .ant-select-selector {
  height: 38px !important;
  min-height: 38px !important;
  max-height: 38px !important;
  align-items: center !important;
}

.dont-send-select.custom-dropdown .ant-select-selection-overflow {
  height: 38px !important;
  min-height: 38px !important;
  max-height: 38px !important;
  align-items: center !important;
  align-content: center !important;
}

.dont-send-select.custom-dropdown .ant-select-selection-overflow-item,
.dont-send-select.custom-dropdown .ant-select-selection-search {
  height: 38px !important;
  align-items: center !important;
  line-height: 38px !important;
}

/* Ensure text + remove icon + caret don't overlap */
.send-to-select.custom-dropdown .ant-select-selector,
.dont-send-select.custom-dropdown .ant-select-selector {
  padding-right: 0 !important;
  padding-inline-end: 32px !important;
}

.send-to-select.custom-dropdown .ant-select-selection-overflow,
.dont-send-select.custom-dropdown .ant-select-selection-overflow {
  padding-right: 0 !important;
  padding-inline-end: 22px !important;
  max-width: calc(100% - 24px) !important;
}

.send-to-select.custom-dropdown .ant-select-arrow,
.dont-send-select.custom-dropdown .ant-select-arrow {
  right: auto !important;
  inset-inline-end: 8px !important;
  z-index: 2;
}

.campaign-select-tag {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.campaign-select-tag__label {
  display: inline-block;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.campaign-select-tag__remove {
  margin-left: 6px;
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

.send-to-select.custom-dropdown .ant-select-selection-item-content,
.dont-send-select.custom-dropdown .ant-select-selection-item-content {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 468px) {
  .page-header {
    padding: 0 6px;
  }
  .Page-header-text {
    max-width: 60%;
    font-size: 10px;
  }
  .page-header .back-button--text {
    padding: 4px 10px;
  }
}
/* =========================================
   💻 TABLET (max-width: 786px)
   ========================================= */
@media (max-width: 786px) {
  .email-campaign-container {
    padding: 0 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .progress-header {
    margin-left: 5px !important;
  }
  .email-campaign-setup {
    max-width: 100%;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }
  .select-all {
    cursor: pointer;
    justify-self: center;
    margin-right: -200px !important;
    margin-top: 20px;
  }
  .form-title {
    font-size: 20px;
    margin-left: 0;
  }
  .form-group {
    margin-left: 0;
  }
  .form-group .form-input {
    width: 100%;
  }
  .cta-input-rows {
    width: 90% !important;
  }
  .form-label-cta {
    margin-left: 0px !important;
  }
  .cta-input-offer {
    min-width: 100% !important;
  }
  .cta-input-label {
    min-width: 100% !important;
  }
  .form-label-cta {
    font-size: 12px !important;
  }
  .generate-btn {
    margin: 5px auto 0 !important;
    width: 70% !important;
    margin-top: 10px !important;
  }
  .setup-box {
    padding: 24px 24px !important;
  }
  .setup-box__button {
    justify-content: center;
  }
  .recipients-section {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  .send-to-btn,
  .dont-send-btn {
    width: 100%;
    padding: 18px;
    font-size: 16px;
    margin-left: 0;
  }
  .ai-generator {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
  }
  .footer-actions {
    justify-content: center;
    gap: 20px;
    margin-right: 0;
  }
  .campaign-cancel-btn,
  .campaign-next-btn {
    min-width: 130px;
    font-size: 16px;
  }
}
.campaign-next {
  width: 100px !important;
}

.custom-dropdown .ant-dropdown-menu {
  padding: 4px !important;
}

.custom-dropdown .ant-dropdown-menu-item {
  font-size: 14px !important;
  padding: 6px 10px !important; /* Less vertical height */
  line-height: 1.2 !important;
  font-family: "Open Sans", sans-serif;
}

/* Optional: reduce overall width and border radius */
.custom-dropdown .ant-dropdown-menu {
  border-radius: 4px !important;
  min-width: 120px !important;
  width: 250px;
  max-height: 300px !important; /* ✅ Limit the height */
  overflow-y: auto !important;
}

.chatbot-send-button.disabled {
  background-color: #cbd5e1;
  cursor: not-allowed;
  opacity: 0.6;
}

.switch-wrapper.disabled {
  cursor: not-allowed;
}

/* Final guard: keep "Optional" directly under Don't Send To */
.recipients-section .dont-send-wrapper {
  max-height: none !important;
  height: auto !important;
  min-height: 0 !important;
  overflow: visible !important;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
}

.recipients-section .dont-send-optional {
  position: static !important;
  display: block;
  margin-top: 6px !important;
  margin-left: 6px !important;
  line-height: 1.2;
}

/* Final recipients layout lock (fix detached caret + optional alignment) */
.email-campaign-container .recipients-section {
  display: flex;
  align-items: flex-start;
  gap: 56px;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown,
.email-campaign-container .recipients-section .dont-send-wrapper {
  width: 360px !important;
  max-width: 360px !important;
  min-width: 360px !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selector,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selector {
  width: 100% !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-arrow,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-arrow {
  right: auto !important;
  inset-inline-end: 12px !important;
}

.email-campaign-container .recipients-section .dont-send-optional {
  margin-left: 0 !important;
}

/* Absolute final fix: equal height controls + optional directly under Don't Send To */
.email-campaign-container .recipients-section .send-to-select.custom-dropdown,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown {
  width: 360px !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selector,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selector {
  height: 46px !important;
  min-height: 46px !important;
  max-height: 46px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selection-overflow,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selection-overflow {
  height: 46px !important;
  min-height: 46px !important;
  max-height: 46px !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selection-overflow-item,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selection-overflow-item {
  max-height: 46px !important;
  display: inline-flex !important;
  align-items: center !important;
}

.email-campaign-container .recipients-section .campaign-select-tag {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.email-campaign-container .recipients-section .dont-send-wrapper {
  width: 360px !important;
  max-width: 360px !important;
  min-width: 360px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 6px !important;
}

.email-campaign-container .recipients-section .dont-send-wrapper .dont-send-select.custom-dropdown {
  width: 100% !important;
  margin-bottom: 0 !important;
}

.email-campaign-container .recipients-section .dont-send-wrapper .dont-send-optional {
  display: block !important;
  width: 100% !important;
  text-align: left !important;
  margin: 0 !important;
  padding-left: 2px;
  position: static !important;
}

/* Final recipients lock: keep both selects same height and Optional under Don't Send To */
.email-campaign-container .recipients-section {
  align-items: flex-start !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown {
  width: 360px !important;
  max-width: 360px !important;
  min-width: 360px !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selector,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selector {
  height: 44px !important;
  min-height: 44px !important;
  max-height: 44px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selection-overflow,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selection-overflow {
  height: 44px !important;
  min-height: 44px !important;
  max-height: 44px !important;
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selection-overflow-item,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selection-overflow-item,
.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selection-search,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selection-search {
  height: 44px !important;
  max-height: 44px !important;
  display: inline-flex !important;
  align-items: center !important;
}

.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-arrow,
.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-arrow {
  right: auto !important;
  inset-inline-end: 12px !important;
}

.email-campaign-container .recipients-section .campaign-select-tag {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.email-campaign-container .recipients-section .dont-send-wrapper {
  width: 360px !important;
  max-width: 360px !important;
  min-width: 360px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 4px !important;
  overflow: visible !important;
}

.email-campaign-container .recipients-section .dont-send-wrapper .dont-send-select.custom-dropdown {
  width: 100% !important;
  margin-bottom: 0 !important;
}

.email-campaign-container .recipients-section .dont-send-wrapper .dont-send-optional {
  display: block !important;
  width: 100% !important;
  text-align: left !important;
  margin: 0 !important;
  padding-left: 0 !important;
  position: static !important;
  line-height: 1.2 !important;
  margin-left: 40px !important;
  margin-top: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/layouts/Engagements/Campaigns/CreateCampaign.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACA,gBAAA;EACA,gBAAA;AAAA;;AAGA,oEAAA;AACA;EACE,mBAAA;AAAF;;AAGA;EACE,4BAAA;EACA,2BAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;;EAEE,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mCAAA;EACA,qBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBC8Ga;ED7Gb,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cClBU;EDmBV,YAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cC9Ba;AD8Bf;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAEA;EACE,mBCtDM;EDuDN,aAAA;EACA,kBC4IU;ED3IV,iBAAA;EACA,YAAA;EACA,yCCsHU;ADrHZ;;AAEA;EACE,eC6Ia;ED5Ib,cC1De;ED2Df,mBAAA;EACA,aAAA;EACA,mBAAA;EACE,oCCsIU;EDrIV,gBC2IiB;ED1InB,SAAA;EACA,kBAAA;AACF;;AACA;EACE,kCAAA;EACA,iBAAA;AAEF;;AAAA;EACE,mBC9EM;ED+EN,YAAA;EACA,kBCmHU;EDlHV,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAGF;;AAAA;EACC,WAAA;EACG,YAAA;AAGJ;;AACA;EACE,eC8Ga;ED7Gb,gBC+GqB;ED9GrB,mBAAA;EACA,cC/Fa;EDgGb,oCCqGY;EDpGZ,iBAAA;AAEF;;AACA;EACE,mBAAA;EACF,iBAAA;AAEA;AADE;EACE,cAAA;EACA,eCgGW;ED/FX,kBAAA;EACA,cC1Ga;ED2Gb,gBCgGmB;ED/FnB,oCCwFU;ADrFd;AAAE;EACE,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBC0EQ;EDzER,gBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;AACF;AACE;EACE,uBAAA;EACA,0BAAA;AACJ;AAEE;EACE,4BAAA;AAAJ;;AAIA;EACE,sBAAA;EACE,eAAA;EACF,iBAAA;AADF;;AAGA;EACE,YAAA;EACA,iBAAA;AAAF;;AAGA;EACE,YAAA;EACA,kBC0CU;EDzCV,yBAAA;EACA,mBC3JM;ED4JN,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,cC5Ja;ED6Jb,eAAA;EACA,gBC6CmB;ED5CnB,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cCnKe;ADmKjB;;AAGA;EACE,cCvKe;ADuKjB;;AAGA;;;EAGE,8BAAA;EACA,gCAAA;AAAF;;AAGA,4DAAA;AACA;EACE,mBCxLmB;EDyLnB,cCrLa;EDsLb,yBAAA;EACA,kBAAA;EACA,kBCMU;EDLV,yCCbU;EDcV,gBCiBmB;EDhBnB,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACI,oCCMQ;ADNd;;AAIA;EACE,cChMU;EDiMR,eAAA;AADJ;;AAIA;EACE,qBAAA;EACA,gBAAA,EAAA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AADF;;AAIA;EACE,QAAA;AADF;;AAIA;EACE,gBCZmB;EDanB,cCtNW;EDuNX,gBAAA;AADF;;AAIA;;EAEE,8BAAA;EACA,yBAAA;EACA,YAAA;AADF;;AAIA;;EAEE,yBAAA;AADF;;AAIA;;EAEE,yBAAA;AADF;;AAGA;EACE,wBAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACI,YAAA;EACA,4BAAA;EACJ,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cC9PW;ED+PX,gBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA,wEAAA;AACA;EACE,uBAAA;EACA,wBAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,YAAA;EACA,eAAA;AAAF;;AAGA;;EAEE,YAAA;EACA,kBClGU;EDmGV,yBAAA;EACA,mBCvSM;EDwSN,gBAAA;EACA,eAAA;EACA,uBAAA;AAAF;;AAGA;;EAEE,cC1Sa;ED2Sb,eAAA;EACA,gBCjGmB;EDkGnB,kBAAA;AAAF;;AAGA;;EAEE,eAAA;EACA,cClTe;ADkTjB;;AAGA;;EAEE,cCvTe;ADuTjB;;AAGA;;;;EAIE,8BAAA;EACA,gCAAA;AAAF;;AAGA,8DAAA;AACA;;EAEE,YAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kBAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,+BAAA;EACA,8BAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,+BAAA;EACA,8BAAA;AAAF;;AAGA;;EAEE,uBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cCvXa;EDwXb,eAAA;EACA,gBC9KmB;AD8KrB;;AAGA;EACE,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,cChYa;EDiYb,eAAA;EACA,gBCvLmB;ADuLrB;;AAGA;;;;;;EAME,6BAAA;AAAF;;AAGA;;;EAGE,8BAAA;AAAF;;AAGA;;EAEE,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;AAAF;;AAGA;;EAEE,yBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cCzae;ED0af,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,cC9aW;ED+aX,eAAA;AAAF;;AAGA;;;;EAIE,0BAAA;EACA,yBAAA;AAAF;;AAGA;;EAEE,cAAA;AAAF;;AAGA,2DAAA;AACA;;EAEE,uBAAA;EACA,0BAAA;EACA,uBAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,oCCrRY;EDsRZ,gBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;;;;;;EAME,0BAAA;AAAF;;AAGA;;;EAGE,0BAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,+BAAA;EACA,8BAAA;EACA,yBAAA;AAAF;;AAGA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mCAAA;AAAF;;AAGA;;EAEE,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;AAAF;;AAGA;;EAEE,kCAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;AAAF;;AAGA;;;;EAIE,8BAAA;EACA,gCAAA;AAAF;;AAGA;;;;;;EAME,8BAAA;EACA,gCAAA;AAAF;;AAGA;EACE,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eC5Xa;ED6Xb,yBCrlBc;EDslBd,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cCrmBM;EDsmBN,oCC5ZY;ED6ZZ,gBCtZqB;ADsZvB;;AAGA;EACE,cC3mBM;ED4mBN,eC/Za;EDgab,gBC7ZmB;ED8ZnB,oCCpaY;ADoad;;AAGA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACE,6BAAA;AAAJ;;AAGA;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBCznBe;ED0nBf,gBAAA;EACA,mBClcU;ADkcZ;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,yBCnpBM;EDopBN,gBAAA;EACA,kBC9ca;AD6cf;;AAIA;EACE,yBC/pBS;AD8pBX;;AAIA;EACE,2BAAA;AADF;;AAIA;EACE,aAAA;EACA,yBAAA,EAAA,2BAAA;EACA,mBAAA;EACA,SAAA,EAAA,4BAAA;EACA,gBAAA;EACE,kBAAA;AADJ;;AAIA;;EAEE,kBAAA;EACA,kBCxeU;EDyeV,gBC5dqB;ED6drB,eAAA;EACA,gBAAA,EAAA,6BAAA;EACA,kBAAA;EACF,eCnee;EDoef,oCCxec;ADued;;AAIA,kBAAA;AACA;EACE,mBCtrBmB;EDurBnB,cCjrBW;EDkrBX,yBAAA;AADF;;AAIA;EACE,mBC3rBiB;ED4rBjB,cCvrBW;ADsrBb;;AAIA,gBAAA;AACA;EACE,mBC9sBc;ED+sBd,cC5rBa;ED6rBb,YAAA;AADF;;AAIA;EACE,mBCltBqB;EDmtBrB,oCAAA;AADF;;AAIA;;8CAAA;AAGA;EACE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,yCCpiBQ;EDmiBV;EAIA;IACE,aAAA;IACA,gBAAA;IACA,kBCxhBQ;EDshBV;EAKA;IACE,mBAAA;IACA,QAAA;IACA,eCrhBW;IDshBX,gBAAA;EAHF;EAMA;IACE,eCvhBW;IDwhBX,cAAA;EAJF;EAOA;IACE,cAAA;EALF;EAME;IACE,eChiBS;ED4hBb;EAME;IACE,WAAA;IACA,eCpiBS;IDqiBT,YAAA;EAJJ;EAOF;IAEE,uBAAA;EANA;EAQA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,cAAA;EANF;EASA;;IAEE,WAAA;IACA,aAAA;IACA,eCxjBW;IDyjBX,cAAA;IACA,8BAAA;EAPF;EASE;;IAEA,eC9jBW;EDujBb;EASA;IACE,eCjkBW;ED0jBb;EASA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,aAAA;EAPF;EAUA;IACE,cAAA;IACA,QAAA;EARF;EAUF;IACC,+BAAA;EARC;EAUA;IACE,0BAAA;IACA,oBAAA;EARF;EAWA;IACE,8BAAA;IACA,oBAAA;IACA,SAAA;IACA,kBAAA;EATF;EAWF;IACI,2BAAA;EATF;EAYF;IACM,4BAAA;EAVJ;EAYF;IACI,qCAAA;IACA,oBAAA;IACA,2BAAA;EAVF;EAaF;IACE,8BAAA;EAXA;EAaF;IACA,sBAAA;IACI,4BAAA;EAXF;EAcF;IACI,6BAAA;EAZF;EAeA;;IAEE,WAAA;IACA,gBAAA;IACA,eCvnBW;ED0mBb;EAeA;IACE,qCAAA;IACA,oBAAA;EAbF;EAeF;IACI,mBAAA;IACA,mBAAA;IACA,8BAAA;IACA,SAAA;EAbF;EAgBA;IACE,aAAA,EAAA,0BAAA;IACA,gBAAA,EAAA,yBAAA;IACA,gBAAA;IACA,0BAAA;EAdF;EAiBA;IACE,SAAA,EAAA,4CAAA;IACA,WAAA;EAfF;AACF;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,oCC1pBY;AD0oBd;;AAmBA;EACE,0CCh3BoB,EDg3BoB,uCAAA;EACxC,gBCxpBqB;EDypBrB,cCr2Ba;ADq1Bf;;AAmBA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,cC/2BW;EDg3BX,iBAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,cCv3Ba;ADu2Bf;;AAmBA,8CAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,cCl4BW;EDm4BX,gBAAA;AAhBF;;AAmBA;;EAEE,YAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,iBAAA;AAhBF;;AAmBA;;EAEE,qBAAA;EACA,kCAAA;EACA,uBAAA;EACA,2BAAA;AAhBF;;AAmBA;;EAEE,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;AAhBF;;AAmBA;;EAEE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;AAhBF;;AAmBA;;EAEE,0BAAA;EACA,yBAAA;EACA,mBAAA;AAhBF;;AAmBA;;EAEE,kCAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;AAhBF;;AAmBA;;EAEE,yBAAA;AAhBF;;AAmBA;;;;EAIE,8BAAA;EACA,gCAAA;AAhBF;;AAmBA,yDAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mBC1+Bc;ED2+Bd,cCx9Ba;EDy9Bb,YAAA;EACA,kBC9xBU;ED+xBV,iBAAA;EACA,eCxxBa;EDyxBb,gBCpxBqB;EDqxBrB,eAAA;AAhBF;;AAmBA;EACE,mBCn/BqB;ADm+BvB;;AAmBA;EACE,wBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;AAhBF;;AAmBA;;EAEE,uBAAA;EACA,2BAAA;AAhBF;;AAmBA;EACE,uBAAA;EACA,2BAAA;AAhBF;;AAmBA;EACE,0BAAA;EACA,cAAA;AAhBF;;AAmBA,iEAAA;AACA;EACE,2BAAA;AAhBF;;AAmBA;EACE,+BAAA;EACA,8BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AAhBF;;AAmBA;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;AAhBF;;AAmBA;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,gCAAA;AAhBF;;AAmBA;;EAEE,uBAAA;EACA,8BAAA;EACA,4BAAA;AAhBF;;AAmBA,oDAAA;AACA;;EAEE,2BAAA;EACA,mCAAA;AAhBF;;AAmBA;;EAEE,2BAAA;EACA,mCAAA;EACA,uCAAA;AAhBF;;AAmBA;;EAEE,sBAAA;EACA,gCAAA;EACA,UAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAhBF;;AAmBA;;EAEE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAhBF;;AAoBA;EACE;IACE,cAAA;EAjBF;EAoBA;IACE,cAAA;IACA,eCn6BW;EDi5Bb;EAqBA;IACE,iBAAA;EAnBF;AACF;AAqBA;;8CAAA;AAGA;EACE;IACE,eAAA;IACA,yCC18BQ;ID28BN,gBAAA;IACJ,mBAAA;EAnBA;EAqBF;IACI,2BAAA;EAnBF;EAqBA;IACE,eAAA;IACA,aAAA;IACA,yCCp9BQ;EDi8BV;EAqBF;IACI,eAAA;IACA,oBAAA;IACA,+BAAA;IACA,gBAAA;EAnBF;EAsBA;IACE,eCh8BW;IDi8BX,cAAA;EApBF;EAuBA;IACE,cAAA;EArBF;EAsBE;IACE,WAAA;EApBJ;EAuBA;IACE,qBAAA;EArBF;EAuBA;IACE,2BAAA;EArBF;EAuBA;IACF,0BAAA;EArBE;EAuBA;IACF,0BAAA;EArBE;EAuBF;IACE,0BAAA;EArBA;EAuBF;IACU,6BAAA;IACF,qBAAA;IACA,2BAAA;EArBN;EAuBA;IACE,6BAAA;EArBF;EAuBF;IAEE,uBAAA;EAtBA;EAwBA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAtBF;EAyBA;;IAEE,WAAA;IACA,aAAA;IACA,eCh/BW;IDi/BX,cAAA;EAvBF;EA0BA;IACE,mBAAA;IACA,mBAAA;IACA,8BAAA;IACA,aAAA;EAxBF;EA2BA;IACE,uBAAA;IACA,SAAA;IACA,eAAA;EAzBF;EA4BA;;IAEE,gBAAA;IACA,eCpgCW;ED0+Bb;AACF;AA6BA;EACE,uBAAA;AA3BF;;AA6BA;EACE,uBAAA;AA1BF;;AA6BA;EACE,0BAAA;EACA,4BAAA,EAAA,yBAAA;EACA,2BAAA;EACA,oCCvhCY;AD6/Bd;;AA6BA,qDAAA;AACA;EACE,6BAAA;EACA,2BAAA;EACI,YAAA;EACA,4BAAA,EAAA,uBAAA;EACJ,2BAAA;AA1BF;;AA4BA;EACE,yBChuCe;EDiuCf,mBAAA;EACA,YAAA;AAzBF;;AA2BA;EACE,mBAAA;AAxBF;;AA2BA,8DAAA;AACA;EACE,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAxBF;;AA2BA;EACE,2BAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;AAxBF;;AA2BA,2EAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAxBF;;AA2BA;;;EAGE,uBAAA;EACA,2BAAA;EACA,2BAAA;AAxBF;;AA2BA;;EAEE,sBAAA;AAxBF;;AA2BA;;EAEE,sBAAA;EACA,iCAAA;AAxBF;;AA2BA;EACE,yBAAA;AAxBF;;AA2BA,sFAAA;AACA;;EAEE,uBAAA;AAxBF;;AA2BA;;EAEE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,wBAAA;EACA,8BAAA;AAxBF;;AA2BA;;EAEE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,4BAAA;AAxBF;;AA2BA;;EAEE,2BAAA;EACA,+BAAA;EACA,8BAAA;AAxBF;;AA2BA;EACE,wBAAA;EACA,2BAAA;AAxBF;;AA2BA;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,iCAAA;EACA,kCAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,sBAAA;EACA,2BAAA;AAxBF;;AA2BA;EACE,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;EACA,iBAAA;EACA,2BAAA;AAxBF;;AA2BA,0FAAA;AACA;EACE,kCAAA;AAxBF;;AA2BA;;EAEE,uBAAA;EACA,2BAAA;EACA,2BAAA;AAxBF;;AA2BA;;EAQE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,wBAAA;EACA,8BAAA;AA9BF;;AAiCA;;EAQE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,4BAAA;AApCF;;AAuCA;;;;EAgBE,uBAAA;EACA,2BAAA;EACA,+BAAA;EACA,8BAAA;AAhDF;;AAmDA;;EAQE,sBAAA;EACA,iCAAA;AAtDF;;AAyDA;EACE,wBAAA;EACA,2BAAA;AAtDF;;AAyDA;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,iCAAA;EACA,kCAAA;EACA,mBAAA;EACA,4BAAA;AAtDF;;AAyDA;EACE,sBAAA;EACA,2BAAA;AAtDF;;AAyDA;EACE,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;AAtDF","sourcesContent":["@import '../../../styles/variables.scss';\r\n\r\n.email-campaign-container{\r\nmin-height: 83vh;\r\nmargin-top: 20px;\r\n}\r\n\r\n/* --- Recipients dropdown overrides (Send To / Don't Send To) --- */\r\n.recipients-section {\r\n  gap: 8px !important;\r\n}\r\n\r\n.recipients-section .filter-dropdown .ant-select-selection-overflow {\r\n  flex-wrap: nowrap !important;\r\n  overflow: hidden !important;\r\n}\r\n\r\n.recipients-section .filter-dropdown .ant-select-selection-overflow-item {\r\n  flex: 0 0 auto !important;\r\n}\r\n\r\n.recipients-section .filter-dropdown .ant-select-selection-search,\r\n.recipients-section .filter-dropdown .ant-select-selection-search-input {\r\n  width: 0 !important;\r\n  min-width: 0 !important;\r\n  height: 0 !important;\r\n  opacity: 0 !important;\r\n  caret-color: transparent !important;\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n.recipients-section .campaign-select-tag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  background-color: $color-e4e4e4;\r\n  border-radius: 12px;\r\n  padding: 0 10px;\r\n  font-size: 14px;\r\n  color: $text-dark;\r\n  height: 26px;\r\n  line-height: 22px;\r\n  max-width: 100%;\r\n}\r\n\r\n.recipients-section .campaign-select-tag__prefix {\r\n  font-weight: 600;\r\n  color: $text-primary;\r\n}\r\n\r\n.recipients-section .campaign-select-tag__label {\r\n  max-width: 160px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recipients-section .campaign-select-tag__remove {\r\n  margin-left: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.recipients-section .campaign-select-tag--rest {\r\n  font-weight: 600;\r\n}\r\n.email-campaign-setup {\r\n  background: $white;\r\n  padding: 20px;\r\n  border-radius: $radius-md;\r\n  max-width: 1300px;\r\n  margin: auto;\r\n  box-shadow: $shadow-md;\r\n}\r\n\r\n.page-header {\r\n  font-size: $font-size-sm;\r\n  color: $text-secondary;\r\n  margin-bottom: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n    font-family: $font-family;\r\n    font-weight: $font-weight-normal;\r\n  gap: 14px;\r\n  text-align: center;\r\n}\r\n.Page-header-text{\r\n  justify-content: center !important;\r\n  margin-top:-15px;\r\n}\r\n.page-header .back-button {\r\n  background: $white;\r\n  padding: 4px;          \r\n  border-radius: $radius-sm;   \r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 5%;\r\n  width: 38px !important;        \r\n  height: 28px;     \r\n}\r\n\r\n.page-header .back-button img {\r\n width: 28px;\r\n    height: 20px;\r\n}\r\n\r\n\r\n.form-title {\r\n  font-size: $font-size-xl;\r\n  font-weight: $font-weight-semibold;\r\n  margin-bottom: 20px;\r\n  color: $text-primary;\r\n  font-family: $font-family;\r\n  margin-left: 37px;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 15px;\r\nmargin-left: 37px;\r\n  .form-label {\r\n    display: block;\r\n    font-size: $font-size-lg;\r\n    margin-bottom: 6px;\r\n    color: $text-secondary;\r\n    font-weight: $font-weight-semibold;\r\n    font-family: $font-family;\r\n  }\r\n\r\n  .form-input {\r\n    width: 400px !important;\r\n    padding: 8px;\r\n    border: 1px solid $border-light;\r\n    border-radius: $radius-sm;\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.recipients-section {\r\n  display: flex;\r\n  margin: 30px 0;\r\n  align-items: flex-start;\r\n\r\n  .filter-dropdown {\r\n    width: 320px !important;\r\n    flex: 0 0 320px !important;\r\n  }\r\n\r\n  .filter-dropdown:first-child {\r\n    margin-left: 37px !important;\r\n  }\r\n}\r\n\r\n.campaign-select-tag__prefix {\r\n  color: #777 !important;\r\n    font-size: 14px;\r\n  margin-right: 6px;\r\n}\r\n.send-to-btn {\r\n  width: 240px;\r\n  margin-left: 37px;\r\n}\r\n\r\n.send-to-btn.styled-input.ant-input-affix-wrapper {\r\n  height: 38px;\r\n  border-radius: $radius-sm;\r\n  border: 1px solid $brand-primary;\r\n  background: $white;\r\n  box-shadow: none;\r\n  padding: 0 12px;\r\n}\r\n\r\n.send-to-btn .ant-input-prefix {\r\n  color: $text-primary;\r\n  font-size: 12px;\r\n  font-weight: $font-weight-normal;\r\n  margin-right: 12px;\r\n}\r\n\r\n.send-to-btn .ant-input {\r\n  font-size: 12px;\r\n  color: $text-secondary;\r\n}\r\n\r\n.send-to-btn .ant-input-suffix {\r\n  color: $text-secondary;\r\n}\r\n\r\n.send-to-btn.styled-input--has-value,\r\n.send-to-btn.styled-input--has-value:hover,\r\n.send-to-btn.styled-input--has-value.ant-input-affix-wrapper-focused {\r\n  background: $white !important;\r\n  border-color: $brand-primary !important;\r\n}\r\n\r\n/* -------------------- Don’t Send To -------------------- */\r\n.dont-send-btn {\r\n  background: $background-default;\r\n  color: $text-primary;\r\n  border: 2px solid $brand-primary;\r\n  padding: 20px 16px;\r\n  border-radius: $radius-sm;\r\n  box-shadow: $shadow-md;\r\n  font-weight: $font-weight-normal;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n      font-family: $font-family;\r\n\r\n}\r\n\r\n.dont-send-btn .recipient-heading {\r\n  color: $text-dark;\r\n    font-size: 14px;\r\n}\r\n\r\n.dont-send-btn .recipient-value {\r\n  display: inline-block;\r\n  max-width: 160px; /* adjust as needed */\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n  margin-left: 6px;\r\n}\r\n\r\n.dont-send-btn {\r\n  gap: 8px;\r\n}\r\n\r\n.dont-send-btn .optional {\r\n  font-weight: $font-weight-normal;\r\n  color: $text-muted;\r\n  margin-left: 4px;\r\n}\r\n\r\n.dont-send-btn:hover,\r\n.dont-send-btn:focus {\r\n  background: $brand-primary !important;\r\n  color: $text-inverse !important;\r\n  border: none;\r\n}\r\n\r\n.dont-send-btn:hover .recipient-heading,\r\n.dont-send-btn:focus .recipient-heading {\r\n  color: $text-inverse !important;\r\n}\r\n\r\n.dont-send-btn:hover .recipient-value,\r\n.dont-send-btn:focus .recipient-value {\r\n  color: $text-inverse !important;\r\n}\r\n.dont-send-dropdown {\r\n  z-index: 2000 !important;\r\n  position: absolute !important;\r\n  overflow: visible !important;\r\n  border-radius: $radius-sm !important;\r\n  min-width: 120px !important;\r\n      width: 250px;\r\n      max-height: 300px !important; \r\n  overflow-y: auto !important; \r\n}\r\n\r\n.dont-send-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.dont-send-optional {\r\n  font-size: 12px;\r\n  color: $text-muted;\r\n  margin-left: 6px;\r\n  line-height: 1;\r\n  margin-top: -2px;\r\n}\r\n\r\n/* Force wrapper height to content (fix large gap under Don't Send To) */\r\n.dont-send-wrapper {\r\n  height: auto !important;\r\n  min-height: 0 !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown,\r\n.dont-send-select.custom-dropdown .ant-select-selector {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n}\r\n\r\n.send-to-btn {\r\n  width: 240px;\r\n  margin-left: 37px;\r\n  flex: 0 0 240px;\r\n}\r\n\r\n.dont-send-btn {\r\n  width: 240px;\r\n  flex: 0 0 240px;\r\n}\r\n\r\n.send-to-btn.styled-input.ant-input-affix-wrapper,\r\n.dont-send-btn.styled-input.ant-input-affix-wrapper {\r\n  height: 38px;\r\n  border-radius: $radius-sm;\r\n  border: 1px solid $brand-primary;\r\n  background: $white;\r\n  box-shadow: none;\r\n  padding: 0 12px;\r\n  width: 240px !important;\r\n}\r\n\r\n.send-to-btn .ant-input-prefix,\r\n.dont-send-btn .ant-input-prefix {\r\n  color: $text-primary;\r\n  font-size: 12px;\r\n  font-weight: $font-weight-normal;\r\n  margin-right: 12px;\r\n}\r\n\r\n.send-to-btn .ant-input,\r\n.dont-send-btn .ant-input {\r\n  font-size: 12px;\r\n  color: $text-secondary;\r\n}\r\n\r\n.send-to-btn .ant-input-suffix,\r\n.dont-send-btn .ant-input-suffix {\r\n  color: $text-secondary;\r\n}\r\n\r\n.send-to-btn.styled-input.ant-input-affix-wrapper:hover,\r\n.dont-send-btn.styled-input.ant-input-affix-wrapper:hover,\r\n.send-to-btn.styled-input.ant-input-affix-wrapper-focused,\r\n.dont-send-btn.styled-input.ant-input-affix-wrapper-focused {\r\n  background: $white !important;\r\n  border-color: $brand-primary !important;\r\n}\r\n\r\n/* --- StyledDropdown layout for Send To / Don't Send To --- */\r\n.send-to-btn.custom-dropdown,\r\n.dont-send-btn.custom-dropdown {\r\n  width: 240px;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selector,\r\n.dont-send-btn.custom-dropdown .ant-select-selector {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n  border-radius: $radius-sm !important;\r\n  border: 1px solid $brand-primary !important;\r\n  background: $white !important;\r\n  box-shadow: none !important;\r\n  padding: 0 12px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  position: relative;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-overflow,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-overflow {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n  align-items: center !important;\r\n  flex-wrap: nowrap !important;\r\n  overflow: hidden !important;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-overflow-item,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-overflow-item {\r\n  height: 38px !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-search,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-search {\r\n  height: 38px !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-search-input,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-search-input {\r\n  height: 38px !important;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selector::before {\r\n  content: \"Send To\";\r\n  position: absolute;\r\n  left: 12px;\r\n  color: $text-primary;\r\n  font-size: 12px;\r\n  font-weight: $font-weight-normal;\r\n}\r\n\r\n.dont-send-btn.custom-dropdown .ant-select-selector::before {\r\n  content: \"Don't Send To\";\r\n  position: absolute;\r\n  left: 12px;\r\n  color: $text-primary;\r\n  font-size: 12px;\r\n  font-weight: $font-weight-normal;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-search,\r\n.send-to-btn.custom-dropdown .ant-select-selection-placeholder,\r\n.send-to-btn.custom-dropdown .ant-select-selection-item,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-search,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-placeholder,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-item {\r\n  padding-left: 72px !important;\r\n}\r\n\r\n.dont-send-btn.custom-dropdown .ant-select-selection-search,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-placeholder,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-item {\r\n  padding-left: 104px !important;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-overflow,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-overflow {\r\n  flex-wrap: nowrap !important;\r\n  overflow: hidden !important;\r\n  white-space: nowrap !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-overflow-item,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-overflow-item {\r\n  flex: 0 1 auto !important;\r\n}\r\n\r\n.campaign-select-tag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  background: transparent;\r\n  border: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  font-size: 12px;\r\n  color: $text-secondary;\r\n  line-height: 1;\r\n}\r\n\r\n.campaign-select-tag__remove {\r\n  font-size: 12px;\r\n  color: $text-muted;\r\n  cursor: pointer;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-placeholder,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-placeholder,\r\n.send-to-btn.custom-dropdown .ant-select-selection-item,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-item {\r\n  font-size: 12px !important;\r\n  color: $text-secondary !important;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .styled-dropdown-caret,\r\n.dont-send-btn.custom-dropdown .styled-dropdown-caret {\r\n  display: block;\r\n}\r\n\r\n/* --- Final overrides for new StyledDropdown classes --- */\r\n.send-to-select.custom-dropdown,\r\n.dont-send-select.custom-dropdown {\r\n  width: 320px !important;\r\n  flex: 0 0 320px !important;\r\n  height: 38px !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown {\r\n  margin-left: 37px !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selector,\r\n.dont-send-select.custom-dropdown .ant-select-selector {\r\n  height: 48px !important;\r\n  min-height: 38px !important;\r\n  border-radius: $radius-md !important;\r\n  border: 1px solid $brand-primary !important;\r\n  background: $white !important;\r\n  box-shadow: none !important;\r\n  padding: 0 12px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  position: relative !important;\r\n  overflow: hidden !important;\r\n  font-family: $font-family;\r\n  font-weight: 400;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selector::before {\r\n  content: none !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown .ant-select-selector::before {\r\n  content: none !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-search,\r\n.send-to-select.custom-dropdown .ant-select-selection-placeholder,\r\n.send-to-select.custom-dropdown .ant-select-selection-item,\r\n.dont-send-select.custom-dropdown .ant-select-selection-search,\r\n.dont-send-select.custom-dropdown .ant-select-selection-placeholder,\r\n.dont-send-select.custom-dropdown .ant-select-selection-item {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown .ant-select-selection-search,\r\n.dont-send-select.custom-dropdown .ant-select-selection-placeholder,\r\n.dont-send-select.custom-dropdown .ant-select-selection-item {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-overflow,\r\n.dont-send-select.custom-dropdown .ant-select-selection-overflow {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n  align-items: center !important;\r\n  flex-wrap: nowrap !important;\r\n  overflow: hidden !important;\r\n  white-space: nowrap !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-overflow {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown .ant-select-selection-overflow {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-overflow-item,\r\n.dont-send-select.custom-dropdown .ant-select-selection-overflow-item {\r\n  height: 38px !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  flex: 0 1 auto !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-search-input,\r\n.dont-send-select.custom-dropdown .ant-select-selection-search-input {\r\n  height: 0 !important;\r\n  width: 0 !important;\r\n  min-width: 0 !important;\r\n  opacity: 0 !important;\r\n  caret-color: transparent !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-search,\r\n.dont-send-select.custom-dropdown .ant-select-selection-search {\r\n  width: 0 !important;\r\n  min-width: 0 !important;\r\n  height: 0 !important;\r\n  flex: 0 0 0 !important;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-item,\r\n.dont-send-select.custom-dropdown .ant-select-selection-item {\r\n  background: transparent !important;\r\n  border: none !important;\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown:hover .ant-select-selector,\r\n.dont-send-select.custom-dropdown:hover .ant-select-selector,\r\n.send-to-select.custom-dropdown.ant-select-focused .ant-select-selector,\r\n.dont-send-select.custom-dropdown.ant-select-focused .ant-select-selector {\r\n  background: $white !important;\r\n  border-color: $brand-primary !important;\r\n}\r\n\r\n.send-to-btn.styled-input--has-value,\r\n.dont-send-btn.styled-input--has-value,\r\n.send-to-btn.styled-input--has-value:hover,\r\n.dont-send-btn.styled-input--has-value:hover,\r\n.send-to-btn.styled-input--has-value.ant-input-affix-wrapper-focused,\r\n.dont-send-btn.styled-input--has-value.ant-input-affix-wrapper-focused {\r\n  background: $white !important;\r\n  border-color: $brand-primary !important;\r\n}\r\n\r\n.ai-generator {\r\n  margin: 0 -20px -20px -20px; \r\n  margin-top: 50px;\r\n  padding: 18px 0;\r\n  border-top: 1px solid $border-default; \r\n  display: flex;\r\n  justify-content: space-between; \r\n  align-items: center;\r\n  font-size: $font-size-md;\r\n  background-color: $brand-primary;\r\n  border-radius: 8px;\r\n}\r\n\r\n.ai-content {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-left: 30px;\r\n}\r\n\r\n.ai-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n  flex: 0 0 28px;\r\n  display: block;\r\n  align-self: center;\r\n}\r\n\r\n.ai-text {\r\n  display: flex;\r\n  flex-direction: column; \r\n  gap: 8px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.ai-label {\r\n  color: $white;\r\n  font-family: $font-family;\r\n  font-weight: $font-weight-semibold;\r\n}\r\n\r\n.ai-subtext {\r\n  color: $white;\r\n  font-size: $font-size-md;\r\n  font-weight: $font-weight-normal;\r\n  font-family: $font-family;\r\n}\r\n\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 44px;\r\n  height: 24px;\r\n    margin-right: 40px !important;\r\n}\r\n\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.switch .slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: $border-default;\r\n  transition: .4s;\r\n  border-radius: $radius-xl;\r\n\r\n}\r\n\r\n.switch .slider::before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 18px;\r\n  width: 18px;\r\n  top: 1px;\r\n  bottom: 3px;\r\n  background-color: $white;\r\n  transition: .4s;\r\n  border-radius: $radius-round;\r\n}\r\n\r\n.switch input:checked + .slider {\r\n  background-color: $blue-400;\r\n}\r\n\r\n.switch input:checked + .slider::before {\r\n  transform: translateX(20px);\r\n}\r\n\r\n.footer-actions {\r\n  display: flex;\r\n  justify-content: flex-end; /* align buttons to right */\r\n  align-items: center;\r\n  gap: 12px; /* spacing between buttons */\r\n  margin-top: 20px;\r\n    margin-right: 45px;\r\n}\r\n\r\n.campaign-cancel-btn,\r\n.campaign-next-btn {\r\n  padding: 10px 20px;\r\n  border-radius: $radius-md;\r\n  font-weight: $font-weight-semibold;\r\n  cursor: pointer;\r\n  min-width: 150px; /* keep uniform button size */\r\n  text-align: center;\r\nfont-size: $font-size-lg;\r\nfont-family: $font-family;\r\n}\r\n\r\n/* Cancel Button */\r\n.campaign-cancel-btn {\r\n  background: $background-default;\r\n  color: $text-muted;\r\n  border: 2px solid $warning;\r\n}\r\n\r\n.campaign-cancel-btn:hover {\r\n  background: $background-light;\r\n  color: $text-muted;\r\n}\r\n\r\n/* Next Button */\r\n.campaign-next-btn {\r\n  background: $brand-primary;\r\n  color: $text-inverse;\r\n  border: none;\r\n}\r\n\r\n.campaign-next-btn:hover {\r\n  background: $brand-primary-strong;\r\n  border: 2px solid $warning !important;\r\n}\r\n\r\n/* =========================================\r\n   📱 MOBILE (max-width: 468px)\r\n   ========================================= */\r\n@media (max-width: 468px) {\r\n  .email-campaign-container {\r\n    margin-top: 10px;\r\n    min-height: auto;\r\n    padding: 0 10px;\r\n    box-shadow: $shadow-md;\r\n  }\r\n\r\n  .email-campaign-setup {\r\n    padding: 15px;\r\n    box-shadow: none;\r\n    border-radius: $radius-sm;\r\n  }\r\n\r\n  .page-header {\r\n    flex-direction: row;\r\n    gap: 8px;\r\n    font-size: $font-size-sm;\r\n    text-align: left;\r\n  }\r\n\r\n  .form-title {\r\n    font-size: $font-size-xl;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .form-group {\r\n    margin-left: 0;\r\n    .form-label {\r\n      font-size: $font-size-md;\r\n    }\r\n    .form-input {\r\n      width: 100%;\r\n      font-size: $font-size-md;\r\n      padding: 8px;\r\n    }\r\n  }\r\n.setup-box__button\r\n {\r\n  justify-content: center;\r\n }\r\n  .recipients-section {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 10px;\r\n    margin: 20px 0;\r\n  }\r\n\r\n  .send-to-btn,\r\n  .dont-send-btn {\r\n    width: 100%;\r\n    padding: 16px;\r\n    font-size: $font-size-sm;\r\n    margin-left: 0;\r\n    justify-content: space-between;\r\n  }\r\n    .send-to-btn,\r\n  .dont-send-btn span{\r\n    font-size: $font-size-sm;\r\n  }\r\n  .dont-send-btn .recipient-value{\r\n    font-size: $font-size-sm;\r\n  }\r\n  .ai-generator {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n    padding: 15px;\r\n  }\r\n\r\n  .ai-text {\r\n    margin-left: 0;\r\n    gap: 4px;\r\n  }\r\n.ai-next-btn {\r\n margin-right: -320px !important;\r\n}\r\n  .switch {\r\n    margin-right: 0 !important;\r\n    align-self: flex-end;\r\n  }\r\n\r\n  .footer-actions {\r\n    flex-direction: column-reverse;\r\n    align-items: stretch;\r\n    gap: 10px;\r\n    margin: 20px 0 0 0;\r\n  }\r\n.categories-step .categories-grid {\r\n    margin-left: 9px !important;\r\n\r\n}\r\n.datetime-row { \r\n      margin-left: 30px !important;\r\n}\r\n.summary-grid {\r\n    grid-template-columns: 1fr !important;\r\n    gap: 10px !important;\r\n    margin-left: 9px !important;\r\n\r\n}\r\n.export-campaign-btn{\r\n  margin-bottom: 20px !important;\r\n}\r\n.email-search-bar {\r\nwidth:110% !important;\r\n    margin-left: 10px !important;\r\n\r\n}\r\n.ai-back-btn {\r\n    margin-right: 70px !important;\r\n\r\n}\r\n  .campaign-cancel-btn,\r\n  .campaign-next-btn {\r\n    width: 100%;\r\n    min-width: unset;\r\n    font-size: $font-size-lg;\r\n  }\r\n  .campaign-type-grid{\r\n    grid-template-columns: 1fr !important;\r\n    gap: 10px !important;\r\n  }\r\n.summary-item {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n  }\r\n\r\n  .summary-item label {\r\n    flex: 0 0 40%;       /* label takes 40% width */\r\n    margin-bottom: 0;    /* remove extra spacing */\r\n    text-align: left;\r\n    font-size: $font-size-sm !important;\r\n  }\r\n\r\n  .summary-item .form-input-summary {\r\n    flex: 1;             /* input stretches to fill remaining space */\r\n    width: 100%;\r\n  }\r\n  \r\n}\r\n.custom-menu .ant-dropdown-menu-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  font-family: $font-family;\r\n}\r\n\r\n.custom-menu .selected-item {\r\n  background-color: $brand-primary-light; /* light blue background for selected */\r\n  font-weight: $font-weight-semibold;\r\n  color: $text-primary;\r\n}\r\n\r\n.menu-item-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  align-items: center;\r\n}\r\n\r\n.remove-icon {\r\n  margin-left: 8px;\r\n  color: $text-muted;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n.remove-icon:hover {\r\n  color: $text-primary;\r\n}\r\n\r\n/* --- Overrides for new dropdown inputs --- */\r\n.dont-send-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.dont-send-optional {\r\n  font-size: 12px;\r\n  color: $text-muted;\r\n  margin-left: 6px;\r\n}\r\n\r\n.send-to-btn,\r\n.dont-send-btn {\r\n  width: 240px;\r\n  flex: 0 0 240px;\r\n}\r\n\r\n.send-to-btn {\r\n  margin-left: 37px;\r\n}\r\n\r\n.send-to-btn.custom-dropdown,\r\n.dont-send-btn.custom-dropdown {\r\n  padding: 0 !important;\r\n  background: transparent !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.send-to-btn.styled-input.ant-input-affix-wrapper,\r\n.dont-send-btn.styled-input.ant-input-affix-wrapper {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n  border-radius: $radius-sm !important;\r\n  border: 1px solid $brand-primary !important;\r\n  background: $white !important;\r\n  box-shadow: none !important;\r\n  padding: 0 12px !important;\r\n  width: 240px !important;\r\n}\r\n\r\n.send-to-btn .ant-input-prefix,\r\n.dont-send-btn .ant-input-prefix {\r\n  color: $text-primary !important;\r\n  font-size: 12px !important;\r\n  font-weight: $font-weight-normal !important;\r\n  margin-right: 12px !important;\r\n  white-space: nowrap;\r\n}\r\n\r\n.send-to-btn .ant-input,\r\n.dont-send-btn .ant-input {\r\n  font-size: 12px !important;\r\n  color: $text-secondary !important;\r\n  white-space: nowrap;\r\n}\r\n\r\n.send-to-btn.custom-dropdown .ant-select-selection-item,\r\n.dont-send-btn.custom-dropdown .ant-select-selection-item {\r\n  background: transparent !important;\r\n  border: none !important;\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n.send-to-btn .ant-input-suffix,\r\n.dont-send-btn .ant-input-suffix {\r\n  color: $text-secondary !important;\r\n}\r\n\r\n.send-to-btn.styled-input.ant-input-affix-wrapper:hover,\r\n.dont-send-btn.styled-input.ant-input-affix-wrapper:hover,\r\n.send-to-btn.styled-input.ant-input-affix-wrapper-focused,\r\n.dont-send-btn.styled-input.ant-input-affix-wrapper-focused {\r\n  background: $white !important;\r\n  border-color: $brand-primary !important;\r\n}\r\n\r\n/* --- Final fixes: header + dont-send optional gap --- */\r\n.page-header {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  margin: 0 0 12px;\r\n}\r\n\r\n.page-header .back-button--text {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: $brand-primary;\r\n  color: $text-inverse;\r\n  border: none;\r\n  border-radius: $radius-md;\r\n  padding: 6px 14px;\r\n  font-size: $font-size-sm;\r\n  font-weight: $font-weight-semibold;\r\n  cursor: pointer;\r\n}\r\n\r\n.page-header .back-button--text:hover {\r\n  background: $brand-primary-strong;\r\n}\r\n\r\n.Page-header-text {\r\n  margin-top: 0 !important;\r\n  text-align: center;\r\n  max-width: 75%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.dont-send-wrapper {\r\n  height: auto !important;\r\n  min-height: 0 !important;\r\n  align-self: flex-start;\r\n  gap: 6px !important;\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown,\r\n.dont-send-select.custom-dropdown .ant-select-selector {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown .ant-select-selection-overflow {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n}\r\n\r\n.dont-send-optional {\r\n  margin-top: 6px !important;\r\n  line-height: 1;\r\n}\r\n\r\n/* Hard clamp: don't allow the Don't Send To control to stretch */\r\n.dont-send-wrapper {\r\n  max-height: 60px !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown {\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n  max-height: 38px !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown .ant-select-selector {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n  max-height: 38px !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown .ant-select-selection-overflow {\r\n  height: 38px !important;\r\n  min-height: 38px !important;\r\n  max-height: 38px !important;\r\n  align-items: center !important;\r\n  align-content: center !important;\r\n}\r\n\r\n.dont-send-select.custom-dropdown .ant-select-selection-overflow-item,\r\n.dont-send-select.custom-dropdown .ant-select-selection-search {\r\n  height: 38px !important;\r\n  align-items: center !important;\r\n  line-height: 38px !important;\r\n}\r\n\r\n/* Ensure text + remove icon + caret don't overlap */\r\n.send-to-select.custom-dropdown .ant-select-selector,\r\n.dont-send-select.custom-dropdown .ant-select-selector {\r\n  padding-right: 0 !important;\r\n  padding-inline-end: 32px !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-overflow,\r\n.dont-send-select.custom-dropdown .ant-select-selection-overflow {\r\n  padding-right: 0 !important;\r\n  padding-inline-end: 22px !important;\r\n  max-width: calc(100% - 24px) !important;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-arrow,\r\n.dont-send-select.custom-dropdown .ant-select-arrow {\r\n  right: auto !important;\r\n  inset-inline-end: 8px !important;\r\n  z-index: 2;\r\n}\r\n\r\n.campaign-select-tag {\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.campaign-select-tag__label {\r\n  display: inline-block;\r\n  max-width: 140px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n}\r\n\r\n.campaign-select-tag__remove {\r\n  margin-left: 6px;\r\n  flex: 0 0 auto;\r\n  position: relative;\r\n  z-index: 2;\r\n  cursor: pointer;\r\n}\r\n\r\n.send-to-select.custom-dropdown .ant-select-selection-item-content,\r\n.dont-send-select.custom-dropdown .ant-select-selection-item-content {\r\n  max-width: 140px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n@media (max-width: 468px) {\r\n  .page-header {\r\n    padding: 0 6px;\r\n  }\r\n\r\n  .Page-header-text {\r\n    max-width: 60%;\r\n    font-size: $font-size-xs;\r\n  }\r\n\r\n  .page-header .back-button--text {\r\n    padding: 4px 10px;\r\n  }\r\n}\r\n/* =========================================\r\n   💻 TABLET (max-width: 786px)\r\n   ========================================= */\r\n@media (max-width: 786px) {\r\n  .email-campaign-container {\r\n    padding: 0 20px;\r\n    box-shadow: $shadow-md;\r\n      margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  }\r\n.progress-header {\r\n    margin-left: 5px !important;\r\n}\r\n  .email-campaign-setup {\r\n    max-width: 100%;\r\n    padding: 20px;\r\n    box-shadow: $shadow-md;\r\n  }\r\n.select-all {\r\n    cursor: pointer;\r\n    justify-self: center;\r\n    margin-right: -200px !important;\r\n    margin-top: 20px;\r\n}\r\n\r\n  .form-title {\r\n    font-size: $font-size-xl;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .form-group {\r\n    margin-left: 0;\r\n    .form-input {\r\n      width: 100%;\r\n    }\r\n  }\r\n  .cta-input-rows{\r\n    width:90% !important;\r\n  }\r\n  .form-label-cta {\r\n    margin-left: 0px !important;\r\n  }\r\n  .cta-input-offer  {\r\nmin-width: 100% !important;\r\n}\r\n  .cta-input-label  {\r\nmin-width: 100% !important;\r\n}\r\n.form-label-cta {\r\n  font-size: $font-size-sm !important;\r\n}\r\n.generate-btn{\r\n          margin: 5px auto 0 !important;\r\n        width: 70% !important;\r\n        margin-top: 10px !important;\r\n}\r\n  .setup-box{\r\n    padding: 24px 24px !important;\r\n  }\r\n.setup-box__button\r\n {\r\n  justify-content: center;\r\n }\r\n  .recipients-section {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .send-to-btn,\r\n  .dont-send-btn {\r\n    width: 100%;\r\n    padding: 18px;\r\n    font-size: $font-size-lg;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .ai-generator {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 20px;\r\n  }\r\n\r\n  .footer-actions {\r\n    justify-content: center;\r\n    gap: 20px;\r\n    margin-right: 0;\r\n  }\r\n\r\n  .campaign-cancel-btn,\r\n  .campaign-next-btn {\r\n    min-width: 130px;\r\n    font-size: $font-size-lg;\r\n  }\r\n}\r\n\r\n.campaign-next{\r\n  width:100px !important;\r\n}\r\n.custom-dropdown .ant-dropdown-menu {\r\n  padding: 4px !important;\r\n}\r\n\r\n.custom-dropdown .ant-dropdown-menu-item {\r\n  font-size: $font-size-md !important;\r\n  padding: 6px 10px !important; /* Less vertical height */\r\n  line-height: 1.2 !important;\r\n  font-family: $font-family;\r\n}\r\n\r\n/* Optional: reduce overall width and border radius */\r\n.custom-dropdown .ant-dropdown-menu {\r\n  border-radius: $radius-sm !important;\r\n  min-width: 120px !important;\r\n      width: 250px;\r\n      max-height: 300px !important;   /* ✅ Limit the height */\r\n  overflow-y: auto !important; \r\n}\r\n.chatbot-send-button.disabled {\r\n  background-color: $border-default;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n.switch-wrapper.disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Final guard: keep \"Optional\" directly under Don't Send To */\r\n.recipients-section .dont-send-wrapper {\r\n  max-height: none !important;\r\n  height: auto !important;\r\n  min-height: 0 !important;\r\n  overflow: visible !important;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-self: flex-start;\r\n}\r\n\r\n.recipients-section .dont-send-optional {\r\n  position: static !important;\r\n  display: block;\r\n  margin-top: 6px !important;\r\n  margin-left: 6px !important;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Final recipients layout lock (fix detached caret + optional alignment) */\r\n.email-campaign-container .recipients-section {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 56px;\r\n}\r\n\r\n.email-campaign-container .recipients-section .send-to-select.custom-dropdown,\r\n.email-campaign-container .recipients-section .dont-send-select.custom-dropdown,\r\n.email-campaign-container .recipients-section .dont-send-wrapper {\r\n  width: 360px !important;\r\n  max-width: 360px !important;\r\n  min-width: 360px !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selector,\r\n.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selector {\r\n  width: 100% !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-arrow,\r\n.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-arrow {\r\n  right: auto !important;\r\n  inset-inline-end: 12px !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .dont-send-optional {\r\n  margin-left: 0 !important;\r\n}\r\n\r\n/* Absolute final fix: equal height controls + optional directly under Don't Send To */\r\n.email-campaign-container .recipients-section .send-to-select.custom-dropdown,\r\n.email-campaign-container .recipients-section .dont-send-select.custom-dropdown {\r\n  width: 360px !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selector,\r\n.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selector {\r\n  height: 46px !important;\r\n  min-height: 46px !important;\r\n  max-height: 46px !important;\r\n  padding-top: 0 !important;\r\n  padding-bottom: 0 !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selection-overflow,\r\n.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selection-overflow {\r\n  height: 46px !important;\r\n  min-height: 46px !important;\r\n  max-height: 46px !important;\r\n  align-items: center !important;\r\n  flex-wrap: nowrap !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .send-to-select.custom-dropdown .ant-select-selection-overflow-item,\r\n.email-campaign-container .recipients-section .dont-send-select.custom-dropdown .ant-select-selection-overflow-item {\r\n  max-height: 46px !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .campaign-select-tag {\r\n  margin-top: 0 !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .dont-send-wrapper {\r\n  width: 360px !important;\r\n  max-width: 360px !important;\r\n  min-width: 360px !important;\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  align-items: flex-start !important;\r\n  gap: 6px !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .dont-send-wrapper .dont-send-select.custom-dropdown {\r\n  width: 100% !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .dont-send-wrapper .dont-send-optional {\r\n  display: block !important;\r\n  width: 100% !important;\r\n  text-align: left !important;\r\n  margin: 0 !important;\r\n  padding-left: 2px;\r\n  position: static !important;\r\n}\r\n\r\n/* Final recipients lock: keep both selects same height and Optional under Don't Send To */\r\n.email-campaign-container .recipients-section {\r\n  align-items: flex-start !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .send-to-select.custom-dropdown,\r\n.email-campaign-container .recipients-section .dont-send-select.custom-dropdown {\r\n  width: 360px !important;\r\n  max-width: 360px !important;\r\n  min-width: 360px !important;\r\n}\r\n\r\n.email-campaign-container\r\n  .recipients-section\r\n  .send-to-select.custom-dropdown\r\n  .ant-select-selector,\r\n.email-campaign-container\r\n  .recipients-section\r\n  .dont-send-select.custom-dropdown\r\n  .ant-select-selector {\r\n  height: 44px !important;\r\n  min-height: 44px !important;\r\n  max-height: 44px !important;\r\n  padding-top: 0 !important;\r\n  padding-bottom: 0 !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.email-campaign-container\r\n  .recipients-section\r\n  .send-to-select.custom-dropdown\r\n  .ant-select-selection-overflow,\r\n.email-campaign-container\r\n  .recipients-section\r\n  .dont-send-select.custom-dropdown\r\n  .ant-select-selection-overflow {\r\n  height: 44px !important;\r\n  min-height: 44px !important;\r\n  max-height: 44px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  flex-wrap: nowrap !important;\r\n}\r\n\r\n.email-campaign-container\r\n  .recipients-section\r\n  .send-to-select.custom-dropdown\r\n  .ant-select-selection-overflow-item,\r\n.email-campaign-container\r\n  .recipients-section\r\n  .dont-send-select.custom-dropdown\r\n  .ant-select-selection-overflow-item,\r\n.email-campaign-container\r\n  .recipients-section\r\n  .send-to-select.custom-dropdown\r\n  .ant-select-selection-search,\r\n.email-campaign-container\r\n  .recipients-section\r\n  .dont-send-select.custom-dropdown\r\n  .ant-select-selection-search {\r\n  height: 44px !important;\r\n  max-height: 44px !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.email-campaign-container\r\n  .recipients-section\r\n  .send-to-select.custom-dropdown\r\n  .ant-select-arrow,\r\n.email-campaign-container\r\n  .recipients-section\r\n  .dont-send-select.custom-dropdown\r\n  .ant-select-arrow {\r\n  right: auto !important;\r\n  inset-inline-end: 12px !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .campaign-select-tag {\r\n  margin-top: 0 !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .dont-send-wrapper {\r\n  width: 360px !important;\r\n  max-width: 360px !important;\r\n  min-width: 360px !important;\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  align-items: flex-start !important;\r\n  gap: 4px !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .dont-send-wrapper .dont-send-select.custom-dropdown {\r\n  width: 100% !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.email-campaign-container .recipients-section .dont-send-wrapper .dont-send-optional {\r\n  display: block !important;\r\n  width: 100% !important;\r\n  text-align: left !important;\r\n  margin: 0 !important;\r\n  padding-left: 0 !important;\r\n  position: static !important;\r\n  line-height: 1.2 !important;\r\n  margin-left: 40px !important;\r\n  margin-top: 10px !important;\r\n}\r\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
